<template>
  <div class="container">
      <p class="img-cover"><img :src="imgUrl"></p>
  </div>
</template>
<script>
export default {
    // 站位图文件
    name: 'coverImg',
    props:{
        receiveProps:{
            type: [String, Object],
            default: () => {}
        },
        name:{
            type: String,
            default: ''
        }
    },
    data(){
        return {
            imgUrl: '',
            imgObj: {
                "dynamic-Carousel": 'http://hrss-tes.oss-cn-beijing.aliyuncs.com/hrss/image/2021/10/1635325771742.png',
                "dynamic-optionButton": 'http://hrss-tes.oss-cn-beijing.aliyuncs.com/hrss/image/2021/10/1635325741804.png',
                "dynamic-articleContent": 'http://hrss-tes.oss-cn-beijing.aliyuncs.com/hrss/image/2021/10/1635325879805.png',
                "dynamic-titleBar": 'http://hrss-tes.oss-cn-beijing.aliyuncs.com/hrss/image/2021/10/1635325717061.png',
                "dynamic-videoBanner": 'http://hrss-tes.oss-cn-beijing.aliyuncs.com/hrss/image/2021/10/1635325792037.png',
                "dynamic-graphicOverlay": 'http://hrss-tes.oss-cn-beijing.aliyuncs.com/hrss/image/2021/10/1635325814147.png',
                "dynamic-graphicCombination": 'http://hrss-tes.oss-cn-beijing.aliyuncs.com/hrss/image/2021/10/1635325834915.png',
                "dynamic-carouselGrid": 'http://hrss-tes.oss-cn-beijing.aliyuncs.com/hrss/image/2021/10/1635325898871.png'
            }
        }
    },
    mounted(){
        this.imgUrl = this.imgObj[this.name]
    }
}
</script>

<style lang="less" scoped>
    .img-cover{
        width: 1200px;
        padding: 24px;
        box-sizing: border-box;
        margin: 0 auto;
        img{
            width: 100%;
            height: 100%;
        }
    }
</style>